module.exports = __webpack_public_path__ + "static/team_4-13aa09a362e4da4320fc6e7a9711be18.jpg";